"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = InputOTP;
var _react = require("react");
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/InputOTP/index.js";
function InputOTP(_ref) {
  var _this = this;
  var _ref$length = _ref.length,
    length = _ref$length === void 0 ? 6 : _ref$length,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? "" : _ref$value,
    onChange = _ref.onChange,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus;
  var inputsRef = (0, _react.useRef)([]);
  var handleInput = function handleInput(e, index) {
    var val = e.target.value.replace(/\D/g, "").slice(0, 1);
    var newOTP = value.split("");
    newOTP[index] = val;
    var otpValue = newOTP.join("");
    onChange(otpValue);
    if (val && index < length - 1) {
      var _inputsRef$current;
      (_inputsRef$current = inputsRef.current[index + 1]) === null || _inputsRef$current === void 0 ? void 0 : _inputsRef$current.focus();
    }
  };
  var handleKeyDown = function handleKeyDown(e, index) {
    if (e.key === "Backspace" && !value[index] && index > 0) {
      var _inputsRef$current2;
      (_inputsRef$current2 = inputsRef.current[index - 1]) === null || _inputsRef$current2 === void 0 ? void 0 : _inputsRef$current2.focus();
    }
  };
  var containerStyle = {
    display: "flex",
    gap: "8px",
    justifyContent: "center"
  };
  var inputStyle = {
    width: "40px",
    height: "50px",
    fontSize: "24px",
    textAlign: "center",
    border: "1px solid #ccc",
    borderRadius: "6px"
  };
  return /*#__PURE__*/React.createElement("div", {
    style: containerStyle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 5
    }
  }, Array.from({
    length: length
  }).map(function (_, i) {
    return /*#__PURE__*/React.createElement("input", {
      key: i,
      type: "text",
      inputMode: "numeric",
      style: inputStyle,
      maxLength: "1",
      value: value[i] || "",
      onChange: function onChange(e) {
        return handleInput(e, i);
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e, i);
      },
      ref: function ref(el) {
        return inputsRef.current[i] = el;
      },
      autoFocus: autoFocus && i === 0,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 9
      }
    });
  }));
}